import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import { rem } from "polished"
import styled, { css } from "styled-components"
import * as S from "../elements"

// @ts-ignore
export const Content = styled(Box)`
  ${S.BasicContentStyle};
  display: flex;
  justify-content: flex-end;
  text-align: left;
  width: 100%;
  flex-direction: column;
  padding: 0 1.5rem;
  min-height: ${rem(65)};
  padding-bottom: 1rem;

  p {
    color: ${(p) => p.theme.colors.text.light};
  }

  @media screen and (min-width: ${breakpoints.small}) {
    padding-bottom: 0;
  }
`

export const Image = styled.img<{ size?: string | null }>`
  transition: all 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  width: 60%;
  height: auto;
  position: absolute;
  top: -5%;
  left: 50%;
  transform: translateX(-40%);

  ${(p) =>
    p.size === "small"
      ? css`
          width: 30%;
          top: 15%;

          @media screen and (min-width: ${breakpoints.small}) {
            width: 50%;
          }
        `
      : p.size === "medium"
      ? css`
          width: 45%;
          top: 10%;

          @media screen and (min-width: ${breakpoints.small}) {
            width: 65%;
          }
        `
      : css`
          @media screen and (min-width: ${breakpoints.small}) {
            top: 5%;
            width: 80%;
            transform: translateX(-37.5%);
          }
        `}
`

export const Anchor = styled(S.Anchor)<{ isLoading?: boolean }>`
  position: relative;
  ${(p) =>
    p.isLoading &&
    css`
      pointer-events: none;
    `}

  &:hover {
    ${Image} {
      transform: translateX(-40%) scale(1.02);
      @media screen and (min-width: ${breakpoints.small}) {
        transform: translateX(-37.5%) scale(1.02);
      }
    }
  }

  &::before {
    padding-top: 90%;

    @media screen and (min-width: ${breakpoints.small}) {
      padding-top: 150%;
    }
  }
`

export const AddItem = styled.button<{ isLoading?: boolean }>`
  background: none;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  padding: 0.5rem;
  z-index: 2;

  ${(p) =>
    p.isLoading &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${(p) => p.theme.colors.purple};
    transition: all 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  }

  &:hover {
    svg {
      fill: ${(p) => p.theme.colors.purpleLight};
      transform: scale(1.1);
    }
  }
`
